// English values of ClientCredentialsScopeGroups_LevelTooltip_<group>_<level>,
// Lokalise project B2B, which stays the source of truth. The catalogue arrives
// as bare keys and nothing in this chain can translate.
const LEVEL_NAMES: Record<string, string> = {
  none: "None",
  read: "Read",
  full_access: "Full Access",
};

const DESCRIPTIONS: Record<string, string> = {
  "*_none": "No access to this resource.",
  compliances_read: "View compliance records.",
  credits_read: "View credit balance.",
  leads_read: "View leads and lead events.",
  listing_verification_read: "View listing verification submissions.",
  listing_verification_full_access:
    "Full permissions for listing verification management.",
  listings_read: "View listings and listing events.",
  listings_full_access:
    "Full permissions, including creating, deleting, publishing, unpublishing, updating, upgrading listings.",
  locations_read: "View location information.",
  projects_read: "View project information.",
  roles_read: "View permissions and manage custom roles.",
  statistics_read: "View statistics data.",
  users_read: "View users and user events.",
  users_full_access:
    "Full permissions, including creating users, updating profiles, managing verifications, viewing users list.",
  webhooks_full_access: "Full permissions to manage webhooks.",
};

export function levelName(level: string): string {
  return LEVEL_NAMES[level] ?? level;
}

// A guessed sentence about what a key can do is worse than an obvious gap.
export function levelDescription(groupKey: string, level: string): string {
  if (level === "none") return DESCRIPTIONS["*_none"];
  return DESCRIPTIONS[`${groupKey}_${level}`] ?? "No description available.";
}
